export const FIELD_TYPE_PRIMAL_ARRAY = [
    'text',
    'longText',
    'number',
    'date',
    'checkbox',
    'range',
    'file',
    'currency',
    'percentage',
    'email'
];
export const FIELD_TYPE_COMPLEX_ARRAY = [
    'singleSelect',
    'multiSelect',
    'radio'
];
export const FIELD_TYPES = [
    ...FIELD_TYPE_PRIMAL_ARRAY,
    ...FIELD_TYPE_COMPLEX_ARRAY
];
export const NUMERIC_FIELD_TYPES = ['currency', 'percentage', 'decimal', 'number'];
